/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */

import { Injectable } from '@angular/core';
import { I18nService } from '@dm/core';

@Injectable({
    providedIn: 'root',
})
export class EulaStrService {
    constructor(private i18nService: I18nService) {}

    i18n = {
        eulaLabel: this.get('home.eulaProtocol_label'),
        signEulaAgreementTitle: this.get('home.eulaProtocol_HuaweiEnterpriseBusinessEndUserLicenseAgreement_title'),
        signEulaAgreementContent: this.get('home.eulaProtocol_HuaweiEnterpriseBusinessEndUserLicenseAgreementContent_msg'),
        signEulaConfirmCheckbox: this.get('home.eulaProtocol_readAdnSignProtocol_checkbox'),
        eulaVersion: this.get('home.eulaProtocol_eulaversion_lab'),
        unSignEulaDisableTip: this.get('home.eulaProtocol_fistSignProtocol_info'),
        signEulaLabel: this.get('home.eulaProtocol_login_signProtocol_checkbox1'),
        eulaProtocol: this.get('home.eulaProtocol_login_signProtocol_checkbox2'),
        okBtn: this.get('common.confirm_button'),
        cancelBtn: this.get('common.cancel_button'),
        period: this.get('common.Punctuation_preiod'),
    };

    get(key: string, params?: boolean | any[], colon?: boolean): string {
        return this.i18nService.get(key, params, colon);
    }
}
